<template>
  <slot>
    <RevButton
      ref="containerAddToCartMobile"
      v-bind="attrs"
      class="min-w-[164px] grow"
      variant="primary"
      @click="onAddToCart"
    >
      {{ i18n(translations.addToCart) }}
    </RevButton>
  </slot>
</template>

<script setup lang="ts">
import { useAttrs, useTemplateRef } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'

import { useAddToCartVisibility } from '~/scopes/product-core/composables/useAddToCartVisibility/useAddToCartVisibility'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useFetchProductTracking } from '~/scopes/product-core/composables/useFetch/useFetchProductTracking/useFetchProductTracking'

import translations from './ContainerAddToCart.translations'
import { useAddToCart } from './composables/useAddToCart/useAddToCart'

const attrs = useAttrs()

const i18n = useI18n()
const { addToCart } = useAddToCart()

const { selectedOffer } = useFetchPickers()
const { data: productResponse } = useFetchProduct()
const { data: productTracking } = useFetchProductTracking()

const rootElement = useTemplateRef<HTMLElement>('containerAddToCartMobile')
const { registerElements } = useAddToCartVisibility()
registerElements(rootElement)

function onAddToCart() {
  if (
    selectedOffer.value &&
    selectedOffer.value.offerLegacyId &&
    productResponse.value
  ) {
    addToCart({
      listingId: selectedOffer.value.offerLegacyId,
      listingPublicId: selectedOffer.value.offerId,
      tracking: {
        ...productTracking.product.value,
        list: 'product_page',
        campaign_id: selectedOffer.value.campaignId,
        population_id: selectedOffer.value.populationId,
      },
      partnerPromoCodes:
        productResponse.value.includedServiceOffers.partnerPromoCodes,
      isTradeInEligible: productResponse.value.isTradeInEligible,
      promoCodes: productResponse.value.promoCodes,
    })
  }
}
</script>
